module.exports = __webpack_public_path__ + "img/plantasks.9b030138.png";